module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.1085/img/asset-marketplace-themes-1x.png"